/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import Cookies from 'js-cookie';
import ReactLoading from 'react-loading';
import InfiniteScroll from 'react-infinite-scroller';
import api from 'api';
import { toast } from 'react-toastify';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { FormControlLabel, Checkbox } from '@mui/material';
import { Header, SideMenuBroker, ProposalItem, Select, Search, Button, Dialog } from 'components';
import { Container, ContentArea, Title, Div, DataArea, LoadingArea, CountArea, ModalButton } from './styles';
import { loadingColor, primary, white, secondary } from 'styles/colorProvider';
import { TiFilter } from 'react-icons/ti';
import moment from 'moment';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { ptBR } from 'date-fns/locale';

const MAX_DATE_RANGE_DAYS = 31;
const validateDateRange = (startStr, endStr) => {
  if (!startStr || !endStr || startStr.length < 10 || endStr.length < 10) return { valid: true };
  const start = moment(startStr, 'DD/MM/YYYY', true);
  const end = moment(endStr, 'DD/MM/YYYY', true);
  if (!start.isValid()) return { valid: false, error: 'Data inicial inválida. Use DD/MM/AAAA.' };
  if (!end.isValid()) return { valid: false, error: 'Data final inválida. Use DD/MM/AAAA.' };
  if (end.isBefore(start)) return { valid: false, error: 'A data final deve ser igual ou posterior à data inicial.' };
  if (end.diff(start, 'days') > MAX_DATE_RANGE_DAYS) {
    return { valid: false, error: `O intervalo não pode ser maior que ${MAX_DATE_RANGE_DAYS} dias (1 mês).` };
  }
  return { valid: true };
};

function Proposals() {
  const scrollParent = useRef();

  const [loading, setLoading] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);
  const [proposalsList, setProposalsList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loadingMore, setLoadingMore] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [hasNextPage, setHasNextPage] = useState();
  const [open, setOpen] = useState(false);
  const [openExport, setOpenExport] = useState(false);
  const [search, setSearch] = useState();
  const [selectStatus, setSelectStatus] = useState([]);
  const [selectedOwner, setSelectedOwner] = useState('all');
  const [startData, setStartdata] = useState('');
  const [endData, setEndData] = useState('');
  const [dateRangeError, setDateRangeError] = useState('');
  const [touchFilter, setTouchFilter] = useState();

  const loadData = async () => {
    setLoading(true);
    setCurrentPage(1);
    const resp = await api({
      method: 'GET',
      url: `/broker-proposals`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: Cookies.get('splitriskwl-authtoken'),
      },
      params: {
        search,
        startdate: startData === '' ? undefined : startData,
        enddate: endData === '' ? undefined : endData,
        status: selectStatus.length ? selectStatus.join(',') : undefined,
        page: 1,
        take: 10,
        owner: selectedOwner,
      },
      json: true,
    });
    setProposalsList(resp?.data?.proposals);
    setTotalCount(resp?.data?.totalCount);
    setHasNextPage(resp?.data?.hasNextPage);
    setLoading(false);
    setTouchFilter(false);
  };

  const handleLoadMore = async () => {
    if (!touchFilter) {
      const page = currentPage + 1;
      if (hasNextPage && !loadingMore) {
        setLoadingMore(true);
        const resp = await api({
          method: 'GET',
          url: `/broker-proposals`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: Cookies.get('splitriskwl-authtoken'),
          },
          params: {
            search,
            startdate: startData === '' ? undefined : startData,
            enddate: endData === '' ? undefined : endData,
            status: selectStatus.length ? selectStatus.join(',') : undefined,
            page,
            take: 10,
            owner: selectedOwner,
          },
          json: true,
        });
        const data = proposalsList;
        const ndata = data.concat(resp?.data?.proposals);
        setCurrentPage(page);
        setProposalsList(ndata);
        setHasNextPage(resp?.data?.hasNextPage);
        setLoadingMore(false);
      }
    }
  };

  const handleClear = () => {
    setSelectStatus([]);
    setSelectedOwner('all');
    setStartdata('');
    setEndData('');
    setDateRangeError('');
  };

  const handleOpenFilter = () => {
    setDateRangeError('');
    setOpen(true);
  };

  const handleDateChange = (field, value) => {
    setDateRangeError('');
    if (field === 'start') setStartdata(value || '');
    else setEndData(value || '');
  };

  const parseDateForPicker = (str) => {
    if (!str || String(str).trim().length < 10) return null;
    const m = moment(str, 'DD/MM/YYYY', true);
    return m.isValid() ? m.toDate() : null;
  };

  const handleExport = async () => {
    const { valid, error: dateError } = validateDateRange(startData, endData);
    if (!valid) {
      toast.error(dateError, { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      return;
    }

    setLoadingExport(true);
    const params = new URLSearchParams();
    params.set('owner', selectedOwner || 'all');
    if (selectStatus.length) params.set('status', selectStatus.join(','));
    if (startData && startData.length >= 10) params.set('startdate', startData);
    if (endData && endData.length >= 10) params.set('enddate', endData);
    const queryString = params.toString() ? `?${params.toString()}` : '';

    try {
      const resp = await api({
        method: 'GET',
        url: `/company-proposals-report/stream${queryString}`,
        headers: { Authorization: Cookies.get('splitriskwl-authtoken') },
        responseType: 'blob',
      });

      const blob = resp?.data;
      if (blob && blob.size > 0) {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `propostas_${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
        toast.success('Download iniciado!', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      } else {
        toast.info('Não há dados para exportar', { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
      }
      setOpenExport(false);
    } catch (err) {
      const data = err?.response?.data;
      let message = 'Não foi possível exportar propostas';
      if (err?.response?.status === 400 && data instanceof Blob) {
        try {
          const text = await data.text();
          const j = JSON.parse(text);
          if (j?.error) message = j.error;
        } catch (_) {}
      } else if (data?.error) message = data.error;
      toast.error(message, { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
    }
    setLoadingExport(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const statusOptions = [
    { value: 'awaiting_inspection', label: 'Aguardando vistoria' },
    { value: 'awaiting_payment', label: 'Aguardando pagamento' },
    { value: 'rejected', label: 'Rejeitada' },
    { value: 'cancelled', label: 'Cancelada' },
    { value: 'awaiting_registration', label: 'Aguardando cadastro' },
    { value: 'expired', label: 'Expirada' },
    { value: 'awaiting_vistei', label: 'Aguardando aprovação de fotos' },
    { value: 'awaiting_complementar', label: 'Aguardando fotos complementares' },
    { value: 'awaiting_complementar_report', label: 'Aguardando aprovação das fotos complementares' },
  ];

  const toggleStatus = (value) => {
    setSelectStatus((prev) => (prev.includes(value) ? prev.filter((s) => s !== value) : [...prev, value]));
  };

  const renderFilterDialog = () => (
    <Dialog open={open} onClose={() => setOpen(false)} width="55%" title="Filtrar proposta">
      <Select height="30px" label="Autor da proposta" value={selectedOwner} onChange={(e) => setSelectedOwner(e.target.value)}>
        <option value={'all'}>Todas as propostas</option>
        <option value={'myproposals'}>Minhas propostas</option>
        <option value={'teamproposals'}>Propostas da minha equipe</option>
      </Select>

      <div style={{ marginBottom: 16, marginTop: 12 }}>
        <label style={{ display: 'block', marginBottom: 8, fontWeight: 500 }}>Filtrar por status</label>
        <FormControlLabel
          control={
            <Checkbox
              checked={selectStatus.length === 0}
              indeterminate={selectStatus.length > 0 && selectStatus.length < statusOptions.length}
              onChange={() => setSelectStatus([])}
            />
          }
          label="Todos os status"
        />
        <div style={{ marginLeft: 8, display: 'flex', flexWrap: 'wrap', gap: '8px 16px', maxWidth: '100%' }}>
          {statusOptions.map((opt) => (
            <FormControlLabel
              key={opt.value}
              control={<Checkbox checked={selectStatus.includes(opt.value)} onChange={() => toggleStatus(opt.value)} />}
              label={opt.label}
              style={{ marginRight: 0 }}
            />
          ))}
        </div>
      </div>

      <div style={{ marginTop: 8 }}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
          <div style={{ marginBottom: 16 }}>
            <DatePicker
              label="Data inicial (criação)"
              value={parseDateForPicker(startData)}
              onChange={(date) => handleDateChange('start', date ? moment(date).format('DD/MM/YYYY') : '')}
              format="dd/MM/yyyy"
              emptyLabel="DD/MM/AAAA"
              invalidDateMessage="Data inválida"
              inputVariant="outlined"
              fullWidth
              cancelLabel="Cancelar"
              okLabel="OK"
            />
          </div>
          <div style={{ marginBottom: 8 }}>
            <DatePicker
              label="Data final (criação)"
              value={parseDateForPicker(endData)}
              onChange={(date) => handleDateChange('end', date ? moment(date).format('DD/MM/YYYY') : '')}
              format="dd/MM/yyyy"
              emptyLabel="DD/MM/AAAA"
              invalidDateMessage="Data inválida"
              inputVariant="outlined"
              fullWidth
              cancelLabel="Cancelar"
              okLabel="OK"
            />
          </div>
        </MuiPickersUtilsProvider>
        <p style={{ margin: '4px 0 0', fontSize: 12, color: '#666' }}>
          Intervalo máximo: 1 mês ({MAX_DATE_RANGE_DAYS} dias). Preencha as duas datas para filtrar por período.
        </p>
        {dateRangeError && <p style={{ margin: '4px 0 0', fontSize: 12, color: '#d32f2f' }}>{dateRangeError}</p>}
      </div>

      <ModalButton>
        <Button
          height="35px"
          outlined
          disabled={selectedOwner === 'all' && selectStatus.length === 0 && !startData && !endData}
          onClick={handleClear}
        >
          Limpar filtros
        </Button>
        <Button
          height="35px"
          onClick={() => {
            const { valid, error } = validateDateRange(startData, endData);
            if (!valid) {
              setDateRangeError(error);
              toast.error(error, { position: toast.POSITION.TOP_RIGHT, theme: 'colored' });
              return;
            }
            setDateRangeError('');
            setTouchFilter(true);
            loadData();
            setOpen(false);
          }}
        >
          Aplicar alterações
        </Button>
      </ModalButton>
    </Dialog>
  );

  const renderExportDialog = () => (
    <Dialog open={openExport} onClose={() => !loadingExport && setOpenExport(false)} width="50%" title="Exportar propostas">
      <Button height="35px" style={{ margin: 0, marginTop: 30 }} onClick={handleExport} disabled={loadingExport}>
        {loadingExport ? <ReactLoading color={white} height={25} width={25} type="spin" /> : 'Exportar'}
      </Button>
    </Dialog>
  );

  return (
    <>
      <Header />
      <Container>
        {renderFilterDialog()}
        {renderExportDialog()}
        <SideMenuBroker />
        <ContentArea>
          <Div>
            <Title>MINHAS PROPOSTAS</Title>
            <div className="containerTitle">
              <Button title="Exportar" height="30px" style={{ marginRight: -5 }} onClick={() => setOpenExport(true)}>
                <RiFileExcel2Fill size={18} />
              </Button>
              <Button title="Filtrar" height="30px" onClick={handleOpenFilter}>
                <TiFilter size={18} />
              </Button>

              <Search
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onClear={() => {
                  setSearch('');
                  loadData();
                }}
                onConfirm={() => loadData()}
              />
            </div>
          </Div>
          <DataArea ref={scrollParent}>
            <InfiniteScroll
              loadMore={handleLoadMore}
              hasMore={hasNextPage}
              useWindow={false}
              getScrollParent={() => scrollParent?.current}
              initialLoad={false}
              style={{ width: '100%', display: 'flex' }}
              threshold={10}
            >
              <div style={{ width: '100%' }}>
                {loading && (
                  <LoadingArea>
                    <ReactLoading color={loadingColor} height={40} width={40} type="spin" />
                  </LoadingArea>
                )}
                {!loading && proposalsList?.map((proposal) => <ProposalItem commercial proposal={proposal} />)}
              </div>
            </InfiniteScroll>

            {!loading && !proposalsList?.length && <p>Nenhuma proposta encontrada</p>}
          </DataArea>
          <CountArea>
            {loadingMore && <ReactLoading color={loadingColor} height={20} width={20} type="spin" />}

            {!loadingMore && !loading && (
              <p style={{ color: primary }}>
                Mostrando {proposalsList?.length} de {totalCount}
              </p>
            )}
          </CountArea>
        </ContentArea>
      </Container>
    </>
  );
}

export default Proposals;
